import React from "react";
import { ErrorMessage, Field } from "formik";
import {
  validateFirstName,
  validateLastName,
} from "../../../utilities/ValidationHelper";
import GeneralStrings from "../../../strings/GeneralStrings.json";

const NameStep = () => {
  const NAME_STEP_STRINGS = GeneralStrings.ENROLL.FORM_LABELS.NAME_STEP;

  return (
    <div className="step">
      <h4 className="step-header">{NAME_STEP_STRINGS.HEADER}</h4>
      <div className="question-container">
        <div className="form-group">
          <Field
            name="firstName"
            className="form-control"
            placeholder={GeneralStrings.FORM.FORM_LABELS.FIRST_NAME}
            validate={validateFirstName}
          />
          <ErrorMessage
            component="span"
            className="form-error"
            name="firstName"
          />
        </div>
        <div className="form-group">
          <Field
            name="lastName"
            className="form-control"
            placeholder={GeneralStrings.FORM.FORM_LABELS.LAST_NAME}
            validate={validateLastName}
          />
          <ErrorMessage
            component="span"
            className="form-error"
            name="lastName"
          />
        </div>
      </div>
    </div>
  );
};

export default NameStep;
